import { useQuery } from "@tanstack/react-query";

import {
  type ActivityEventType,
  type ActivityLogSortColumn,
  getActivityLog,
  type SortOrder,
} from "Dashboard/Api/activityLogApi";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTIVITY_LOG_QUERY_KEYS } from "./queryKeys";

export interface UseActivityLogQueryParams {
  offset?: number;
  limit?: number;
  activityEventType?: ActivityEventType;
  dateFrom?: string;
  dateTo?: string;
  sortBy?: ActivityLogSortColumn;
  sortOrder?: SortOrder;
}

export function useActivityLogQuery(params: UseActivityLogQueryParams) {
  return useQuery({
    queryKey: ACTIVITY_LOG_QUERY_KEYS.list(params),
    queryFn: processResponse(() =>
      getActivityLog(
        params.limit,
        params.offset,
        params.activityEventType,
        params.dateFrom,
        params.dateTo,
        params.sortBy,
        params.sortOrder,
      ),
    ),
  });
}
